// extracted by mini-css-extract-plugin
export default {"headerBack":"About_headerBack__bZQha","container":"About_container__N-UYc","btnRow":"About_btnRow__lAgrQ","btn":"About_btn__47Me6"};